module.exports = function() {
  return new Worker(__webpack_public_path__ + "e6b2287e215db3531c9f.worker.js");
};